import { useQuery } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'
import { fetchData } from 'src/api/api-utilities'

const fetchHomepageBlocks = async (eventId) => {
  const response = await fetchData('/my_evanta/homepage/', { eventId })
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response.data
}

const useFetchHomepageBlocks = () => {
  const { eventId } = useParams()

  const { data, isLoading } = useQuery({
    queryKey: [`homepage_blocks_${eventId}`],
    queryFn: () => fetchHomepageBlocks(eventId),
    enabled: !!eventId,
    staleTime: Infinity,
    retry: false
  })

  const homepageBlocks = isEmpty(data) ? [] : data.homepage?.homepage_blocks

  return {
    homepageBlocks,
    isLoadingHomepageBlocks: isLoading
  }
}

export default useFetchHomepageBlocks
